export const getEmailSentDate = (request) => {
  if (request?.emailSentDate) {
    return request.emailSentDate;
  }
  const created = new Date(request?.createdAt);
  const updated = new Date(request?.updatedAt);
  
  if (updated > created) {
    return request.updatedAt;
  }
  
  return null;
};